import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ServiceData, ServiceCategoryData, AdministrationResultStatus, TermData } from 'src/app/clients/system-api/SystemApiClient';
import { ServiceCategoryService } from 'src/app/services/service-category.service';
import { ServiceService } from 'src/app/services/service.service';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { TermService } from 'src/app/services/term.service';

@Component({
  selector: 'app-service-popup',
  templateUrl: './service-popup.component.html',
  styleUrls: ['./service-popup.component.scss']
})
export class ServicePopupComponent implements OnInit {
  @Input() serviceId?: number;
  @Output() close = new EventEmitter<boolean>();  

  serviceData = {} as ServiceData | undefined;
  
  serviceCategoryData: ServiceCategoryData[] | undefined = [];
  showError: boolean = false;
  editMode: boolean = false;
  showTermsCancelScreen: boolean = false;
  showDeleteScreen: boolean = false;
  negatedTermsToCancel: TermData[] | undefined = undefined;
  originalStatus: boolean | undefined = undefined;

  constructor(
              private serviceService: ServiceService,
              private serviceCategoryService: ServiceCategoryService,
              private termService: TermService,
              public router: Router,
              private _snackBarService: SnackBarService,
              private route: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    this.negatedTermsToCancel = undefined;

    if (this.serviceId != undefined) {
      this.editMode = true;
      this.serviceService.retrieveServiceById(this.serviceId).subscribe(result => {
        if (result.status == AdministrationResultStatus.Success) {
          this.serviceData = result.content!;
          this.originalStatus = this.serviceData.active;
        } else {
          this._snackBarService.callSnackBar(result, 'RetrieveFail')
          this.closePopup();
        }
      })
    } else {
      this.editMode = false;
      this.showTermsCancelScreen = false;
      this.showDeleteScreen = false;
      this.originalStatus = undefined;
    }

    this.serviceCategoryService.retrieveAllServiceCategories().subscribe((data) => {
      if(data.status == AdministrationResultStatus.Success) {
        this.serviceCategoryData = data.content?.items;
      } else {
        this._snackBarService.callSnackBar(data, 'RetrieveFail');
      }
    });
  }

  closePopup() {
    this.close.emit();
  }

  onChange(event: any) {
    if (this.serviceData != undefined)
      this.serviceData.description = event.target.value
  }

  checkForNegatedTerms(fromDelete: boolean = false){
    if(this.serviceData != null && this.editMode && (fromDelete || this.serviceData.active === false)) {
      this.negatedTermsToCancel = undefined;
      this.termService.retrieveNegatedTermsByServiceRemoval([this.serviceData]).subscribe((data) => {
        if(data.status == AdministrationResultStatus.Success && data.content !== undefined && data.content !== null && data.content.length > 0){
          this.negatedTermsToCancel = data.content;
          if(!fromDelete){ this.showTermsCancelScreen = true; }
        } else {
          this.showTermsCancelScreen = false;
          this.negatedTermsToCancel = undefined;
          if(fromDelete){ this.deleteService(); }
          else {
            this.submit();
          }
        }
      });
    }
  }

  deleteService() {
    if (this.serviceData != null && this.serviceData.id != undefined) {
      this.serviceService.removeService(this.serviceData.id).subscribe((data) => {
        if (data == AdministrationResultStatus.Success) {
          this._snackBarService.callSnackBar(data, "Successfully deleted");
          this.closePopup();
        } else {
          this._snackBarService.callSnackBar(data, "Error");
        }
      })
    }
  }

  public async submitWithTermsCancel(): Promise<void> {
    if (this.negatedTermsToCancel && this.negatedTermsToCancel.length > 0) {
    
      for (const term of this.negatedTermsToCancel) {
        if(term.id){ await this.cancelTerm(term.id); }
      }
    }

    this.submit();
  }

  public async deleteWithTermsCancel(): Promise<void> {
    if (this.negatedTermsToCancel && this.negatedTermsToCancel.length > 0) {
    
      for (const term of this.negatedTermsToCancel) {
        if(term.id){ await this.cancelTerm(term.id); }
      }
    }

    this.deleteService();
  }

  private async cancelTerm(termId: number): Promise<void> {
    return new Promise<void>((resolve) => {
      const sub = this.termService.cancelTerm(termId).subscribe((data) => {
        if (data === AdministrationResultStatus.Success) {
          resolve();
        } else {
          resolve();
        }
      });
      sub.add(() => sub.unsubscribe());
    });
  }

  submit() {
    if (this.serviceData != null) {
      this.serviceId == undefined ? this.serviceService.addService(this.serviceData).subscribe((data) => {
        if (data == AdministrationResultStatus.Success) {
          this._snackBarService.callSnackBar(data, "Successfully entered");
          this.closePopup();
        } else if (data == AdministrationResultStatus.RecordAlreadyExists) {
          this.showError = true;
        } else {
          this._snackBarService.callSnackBar(data);
        }
      }) : this.serviceService.editService(this.serviceData).subscribe((data) => {
        if (data == AdministrationResultStatus.Success) {
          this._snackBarService.callSnackBar(data, "Successfully entered");
          this.closePopup();
        } else if (data == AdministrationResultStatus.RecordAlreadyExists) {
          this.showError = true
        } else {
          this._snackBarService.callSnackBar(data, "Error");
        }
      })
    }
  }
}
